import { factoryService, getFileRequest, getJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BASE_URL, REACT_APP_TEMPORARY_UNIONS_BASE_URL } from '../config/settings/environment'
import { normalizeDniSlashes } from '../modules/utils/normalizeForeignDni'

/**
 * Gets temporary unions summary for a given seller.
 */
export const getTemporaryUnionsSummary = factoryService(({ dni }) => {
  return getJsonRequest(
    `${REACT_APP_TEMPORARY_UNIONS_BASE_URL}/v1/habilidad-en-bloque/empresa/${normalizeDniSlashes(dni)}`
  )
})

/**
 * Gets temporary union certificate in PDF for a given bidID.
 */
export const getTemporaryUnionsCertificatePdf = factoryService(({ bidID }) =>
  getFileRequest(`${REACT_APP_API_BASE_URL}/v1/pdf/certificado/habilidad/utp/${bidID}`)
)
